import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const CSRF_COOKIE = "neetone_csrf";
const CSRF_HEADER = "X-NeetOne-CSRF";
const SAFE_METHODS = new Set(["get", "head", "options"]);

export const api = axios.create({ baseURL: API, withCredentials: true });

const cookieValue = (name) => {
  const part = document.cookie.split("; ").find((value) => value.startsWith(`${name}=`));
  return part ? decodeURIComponent(part.slice(name.length + 1)) : null;
};

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  const csrfToken = cookieValue(CSRF_COOKIE);
  if (!SAFE_METHODS.has(method) && csrfToken) config.headers[CSRF_HEADER] = csrfToken;
  return config;
});

export const errMsg = (e) =>
  e?.response?.data?.detail
    ? typeof e.response.data.detail === "string"
      ? e.response.data.detail
      : JSON.stringify(e.response.data.detail)
    : e?.message || "Something went wrong";

export const inr = (n) =>
  n == null ? "—" : `₹${Number(n).toLocaleString("en-IN")}`;
